import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

type MatchStatus = "true_match" | "false_positive" | "unknown";

interface Params {
  /** One entry per match. Each keeps its own status and comment. */
  matches: { match_id: number; status: MatchStatus; comment: string }[];
}

/**
 * Best-effort, not all-or-nothing: a match that fails (not found, already in
 * that status, or its write-back to Verifications failed) is reported as
 * failed and the rest are still applied.
 */
export interface BulkMatchStatusResult {
  id: number;
  status: "updated" | "failed";
  detail?: string;
}

export const useBulkUpdateScreeningMatchStatus = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) =>
    axios.patch<{ results: BulkMatchStatusResult[] }>(
      `${env.verifyServiceUrl}individual/screening_match/bulk-status/`,
      { matches: params.matches },
      { headers: { Authorization: authHeader } },
    ),
  );
};
